import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

import { parityColor } from '@shared/models/styles.model';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'slider-thumb',
  templateUrl: './slider-thumb.component.html',
  styleUrls: ['./slider-thumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon],
})
export class SliderThumb {
  @Input() set color(color: string) {
    this.backgroundColor = color;
    this.textColor = parityColor(color);
  }

  @Input() questionNumber = 0;

  @Input() checked = false;

  @HostBinding('style.background-color')
  backgroundColor?: string;

  @HostBinding('style.color')
  textColor?: string;
}
